
import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { EnvironmentKeys } from 'src/environments/environment-keys';
import { LoggedUser } from '../../authentication/authentication';
import { ConfigService } from '../../json-config.service';
import { NativeSafeZoneService } from '../../native-safe-zone.service';
import { ApiAddressOut, ConsultantStatus } from '../../rest-api/rest-api';
import { UserService } from '../../user/user.service';
import { ModalService } from '../modal.service';
import { RedirectService } from '../../redirect.service';
import { SafeUrl } from '@angular/platform-browser';

export const MODAL_BODY_CLASS = 'modal-open';

@Component({
  selector: 'libero-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalComponent implements OnInit, OnDestroy {
  public consultStatus = ConsultantStatus;
  public display!: Observable<string>;

  public EnvironmentKeys = EnvironmentKeys;
  private displaySubscription!: Subscription;

  public get loggedUser(): LoggedUser | null {
    return this.userService.loggedUser;
  }

  public get hasAnyPortfolioOrStrategy(): boolean {
    return this.userService.hasAnyPortfolioOrStrategy;
  }

  public get userDomicileAddress(): ApiAddressOut | null {
    return this.loggedUser?.addresses.find(address => address.type === 'DOMICILE') ?? null;
  }

  public get userPostalAddress(): ApiAddressOut | null {
    return this.loggedUser?.addresses.find(address => address.type === 'POSTAL') ?? null;
  }

  public get consultImage(): string | SafeUrl | null {
    return (this.modalService.consultant &&
    (this.modalService.consultant.image.status !== ConsultantStatus.BLANK && this.modalService.consultant.image.status !== ConsultantStatus.NOT_FOUND))
      ? this.modalService.consultant.image.value : null;
  }

  public constructor(
    public modalService: ModalService,
    private renderer: Renderer2,
    public configService: ConfigService,
    public nativeSafeZoneService: NativeSafeZoneService,
    private userService: UserService,
    private redirectService: RedirectService,
  ) {}

  public ngOnInit(): void {
    this.display = this.modalService.watch();
    this.displaySubscription = this.display.subscribe({
      next: this.modalToggled.bind(this),
    });
  }

  private modalToggled(): void {
    if(this.modalService.containsNotNullData || this.modalService.preloader) {
      this.renderer.addClass(document.body, MODAL_BODY_CLASS);
    } else {
      this.renderer.removeClass(document.body, MODAL_BODY_CLASS)
    }
  }

  public closeModal(forceRefreshRoute?: string): void {
    this.renderer.removeClass(document.body, MODAL_BODY_CLASS);
    this.modalService.close(forceRefreshRoute);
  }

  public ngOnDestroy(): void {
    this.displaySubscription.unsubscribe();
  }

  public goToInvestmentQuestionaireForm(): void {
    this.redirectService.goToInvestmentQuestionaireExternalForm();
  }

  public get opfFeeImplVariant(): string {
    if (
      this.modalService.feeConfigs?.opfFeeImplementation === true ||
      this.modalService.feeConfigs?.opfFeeImplementation === false
    ) {
      return (this.modalService.feeConfigs?.opfFeeImplementation ? 'true' : 'false');
    }
    return '';
  }
}
